'use strict';
import { BaseFilter } from './base-filter';

export class BaseInlineFilter extends BaseFilter {
	init(column) {
		Object.defineProperty(this, '_column', { enumerable: false, value: column });

		const debouncedApply = $.debounce(100, this.applyInlineFilter.bind(this));

		Object.defineProperties(this, {
			inlineFilter: {
				value: true,
			},
			inlineValue: {
				get: function () {
					return this._inlineValue;
				},
				set: function (newValue) {
					this._inlineValue = newValue;
					debouncedApply();
				},
			},
		});

		this.operatorOnForm = this.operators[0].value;
		this.setDefault();
		this.setDefaultInline();
		this.value = this.getNewInlineValue();
		this.operator = this.operatorOnForm;
	}

	getNewValue() {
		return [''];
	}

	getNewInlineValue() {
		return [this.inlineValue || ''];
	}

	isInlineValueChanged() {
		return !angular.equals(this.getNewInlineValue(), this.value);
	}

	setDefaultInline() {
		this._inlineValue = '';
		this.inlineMode = true;
	}

	syncFormFromInline() {}

	hasValue() {
		return Boolean(this.value && this.value[0]);
	}

	clearFilter() {
		this.setDefault();

		this.operator = this.operatorOnForm;
		this.title = '';

		this.setDefaultInline();
		this.applyInlineFilter(true);
	}

	applyInlineFilter(urgent) {
		if (!this.isInlineValueChanged() && !urgent) {
			return;
		}
		this.inlineMode = true;
		this.value = this.getNewInlineValue();

		this.operatorOnForm = this.operator;
		this.operatorTitle = this.getOperatorTitle();
		this.operatorLabel = this.getOperatorLabel();
		this.syncFormFromInline(this.inlineValue);
		this.updateTitle();

		if (typeof this.changeHandler === 'function') {
			this.changeHandler(this, urgent);
		}
	}

	applyFilter() {
		this.inlineMode = false;
		BaseFilter.prototype.applyFilter.apply(this, arguments);
		this._inlineValue = this.title;
	}
}
